import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-selecionar-arquivo-boleto-pedido-modal',
  templateUrl: './selecionar-arquivo-boleto-pedido-modal.component.html',
  styleUrls: ['./selecionar-arquivo-boleto-pedido-modal.component.scss']
})
export class SelecionarArquivoBoletoPedidoModalComponent implements OnInit {
  fileNames: string[];

  constructor(
    private dialogRef: MatDialogRef<SelecionarArquivoBoletoPedidoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.fileNames = this.data.fileNames;
  }

  ngOnInit(): void {
  }

  selecionar(fileName) {
    this.dialogRef.close(fileName);
  }

  fechar() {
    this.dialogRef.close();
  }

}
